<template>
  <div>
    <el-table v-loading="loadTable" :data="records" stripe>
      <el-table-column label="设备编号" prop="chargingPile.id" />
      <el-table-column label="主机二维码" prop="deviceQrCode.id" />
      <el-table-column label="设备名称" prop="chargingPile.name" />
      <el-table-column label="异常信息">
        <template slot-scope="scope">
          {{ getExceptionContent(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="处理状态">
        <template slot-scope="scope">
          {{ scope.row.status == 0 ? "未处理" : "已处理" }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="100" prop="creatTime">
        <template slot-scope="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="处理时间" min-width="100" prop="disposeTime">
        <template slot-scope="scope">
          {{ timeFormat(scope.row.disposeTime) }}
        </template>
      </el-table-column>
      <!-- <el-table-column :width="150" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 0"
            size="mini"
            type="primary"
            @click="handleExceptionInfo(scope.row.id)"
            >处理异常</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <page :current="current" :size="size" :total="total" />
  </div>
</template>

<script>
import maintainDisposeChargingPileException from "@/maintain/api/device/charging-pile-exception/maintainDisposeChargingPileException";
import maintainGetChargingPileExceptionByPage from "@/maintain/api/device/charging-pile-exception/maintainGetChargingPileExceptionByPage";

import Page from "@/components/Page";
import createdMixin from "@/mixin/createdMixin";
import pageMixin from "@/mixin/pageMixin";
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "DeviceExceptionInfoYes",
  components: {
    Page,
  },
  mixins: [pageMixin, timeMixin, createdMixin],
  props: ["checkList"],
  data() {
    return {
      records: [],
      time: [],
      params: {
        pageNum: 1,
        size: 10,
      },
      loadTable: true,
    };
  },
  methods: {
    fetchData() {
      this.params.pageNum = this.current;
      this.params.size = this.size;
      this.params.status = 1;
      this.params.checkList = this.checkList;

      maintainGetChargingPileExceptionByPage(this.params)
        .then((res) => {
          this.records = res.data.records;
          this.total = res.data.total;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    handleExceptionInfo(id) {
      maintainDisposeChargingPileException(id).then(() => {
        this.$message.success("处理成功~");
        this.fetchData();
      });
    },
    reset: function () {
      this.current = 1;
      this.fetchData();
    },
    getExceptionContent(row) {
      switch (row.type) {
        case 0:
          return `0功率异常`;
        case 1:
          return `离线未上线`;
        case 2:
          return `${row.socketNum}号插座,连续五次以上充电时间不足10分钟`;
        case 3:
          return `连续30天无人使用`;
      }
    },
  },
};
</script>

<style scoped></style>
